/**
 * Strips Markdown syntax markers from a text string to return a clean plain-text preview.
 * Useful for summary previews where raw formatting signs look unpolished.
 * 
 * @param {string} text The markdown-formatted text
 * @returns {string} Clean plain text
 */
export const stripMarkdown = (text) => {
  if (!text) return '';
  
  return text
    // Remove HTML tags
    .replace(/<[^>]*>/g, '')
    // Remove image syntax ![alt](url)
    .replace(/!\[(.*?)\]\(.*?\)/g, '$1')
    // Remove link syntax [text](url)
    .replace(/\[(.*?)\]\(.*?\)/g, '$1')
    // Remove bold/italic formatting
    .replace(/(\*\*|__)(.*?)\1/g, '$2')
    .replace(/(\*|_)(.*?)\1/g, '$2')
    // Remove inline code formatting
    .replace(/`(.*?)`/g, '$1')
    // Remove block code blocks
    .replace(/```[\s\S]*?```/g, '')
    // Remove headers (# Title)
    .replace(/^\s*#+\s+/gm, '')
    // Remove blockquotes (> Text)
    .replace(/^\s*>\s+/gm, '')
    // Remove list bullets (*, -, + or 1.)
    .replace(/^\s*[-*+]\s+/gm, '')
    .replace(/^\s*\d+\.\s+/gm, '')
    // Remove horizontal lines (--- or ===)
    .replace(/^\s*[-=]{3,}\s*$/gm, '')
    // Replace multiple newlines/whitespace with a single space
    .replace(/\s+/g, ' ')
    .trim();
};
